import {PreloadedMedia} from '../type/PreloadedMedia.interface';

// preloadMedia에 해당 url이 저장되어 있는 지 확인 후 dataUrl 또는 일반 url을 반환해줍니다
export function getDataUrlOrUrl(url: string, preloadedMedia?: PreloadedMedia) {
  if (
    preloadedMedia &&
    Object.prototype.hasOwnProperty.call(preloadedMedia, url) &&
    preloadedMedia[url].dataUrl
  ) {
    return preloadedMedia[url].dataUrl!;
  }
  return url;
}
